export default __webpack_public_path__ + "static/media/31.a99ffe7f.png";